import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomeComponent } from './pages/home/home.component';
import { RegisterComponent } from './pages/register/register.component';
import { RequestsComponent } from './pages/requests/requests.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { SigninComponent } from './pages/signin/signin.component';
import { SingleWebhookComponent } from './pages/single-webhook/single-webhook.component';
import { UpdatePasswordComponent } from './pages/update-password/update-password.component';
import { WebhooksComponent } from './pages/webhooks/webhooks.component';

const routes: Routes = [
  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  { path: 'signin', title: ' Signin ', component: SigninComponent },
  { path: "register", title: ' Register ', component: RegisterComponent },
  { path: "reset-password", title: ' Reset Password ',  
  children: [
    {path: '', component: ResetPasswordComponent, },
    {path: ':token', component: UpdatePasswordComponent},
  ] },
  // { path: "update-password", title: ' Update Password ', component: UpdatePasswordComponent },
  { path: "dashboard", title: ' Dashboard ', component: DashboardComponent
    // children: [
    //   {
    //     path: 'webhooks',
    //     loadChildren: ()=>import('./pages/webhooks/webhooks.module').then(m => m.WebhooksModule),
    //     canActivate: [AuthGuard]
    //   },
    //   {
    //     path: 'requests',
    //     loadChildren: ()=>import('./pages/requests/requests.module').then(m => m.RequestsModule),
    //     canActivate: [AuthGuard]
    //   },
    //   {
    //     path: 'settings',
    //     loadChildren: ()=>import('./pages/settings/settings.module').then(m => m.SettingsModule),
    //     canActivate: [AuthGuard]
    //   },
    //   {
    //     path: 'home',
    //     loadChildren: ()=>import('./pages/home/home.module').then(m => m.HomeModule),
    //     canActivate: [AuthGuard]
    //   },
    // ]
  },
  { path: "webhooks",
    children: [
      {path: '', title: ' Webhooks ', component: WebhooksComponent, canActivate: [AuthGuard]},
      {path: ':id', title: ' Webhooks ', component: SingleWebhookComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: "requests", title: ' Requests ', component: RequestsComponent, canActivate:[AuthGuard] },
  { path: "settings", title: ' Settings ', component: SettingsComponent, canActivate:[AuthGuard] },
  { path: "home", title: ' Home ', component: HomeComponent, canActivate:[AuthGuard] },
  // { path: "single-webhook/:id", component: SingleWebhookComponent, canActivate:[AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
